/*=========================================================================================
  File Name: moduleCalendarMutations.js
  Description: Calendar Module Mutations
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/


export default {
  SET_SESSIONS (state, sessions) {
    state.sessions = sessions
  },
  SET_SESSIONSMAPPING (state, sessionsmapping) {
    state.sessionsmapping = sessionsmapping
  },
  REMOVE_RECORD (state, itemId) {
    const sessionIndex = state.sessions.findIndex((u) => u.SessionId === itemId)
    state.sessions.splice(sessionIndex, 1)
  }
}
